// Campos editables por sección
export const requestEditableSections = [
  {
    title: "Datos personales",
    fields: [
      {
        name: "firstName",
        label: "Nombres",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "lastName",
        label: "Apellidos",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "documentType",
        label: "Tipo de documento",
        type: "select",
        width: "w-3",
        optionsKey: "documentTypes",
      },
      {
        name: "document",
        label: "Número de documento",
        type: "tel",
        width: "w-3",
        maxLength: 20,
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "phone",
        label: "Celular",
        type: "tel",
        width: "w-3",
        maxLength: 10,
      },
      {
        name: "occupation",
        label: "Ocupación",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "dependents",
        label: "Personas a cargo",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "peopleWhoWillLive",
        label: "No. de personas que habitarán",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "monthlyExpenses",
        label: "Gastos mensuales",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "monthlyIncome",
        label: "Ingresos mensuales",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "userType",
        label: "Tipo de persona",
        type: "select",
        width: "w-3",
        optionsKey: "requestTypes",
      },
    ],
  },
  {
    title: "Vivienda actual",
    fields: [
      {
        name: "actualProperty.type",
        label: "Tipo de propiedad",
        type: "select",
        width: "w-3",
        optionsKey: "actualPropertyTypes",
      },
      {
        name: "actualProperty.address",
        label: "Dirección",
        type: "text",
        width: "w-3",
        maxLength: 150,
      },
      {
        name: "actualProperty.neighborhood",
        label: "Barrio/Sector",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "actualProperty.actualPropertyProvince",
        label: "Departamento",
        type: "select",
        width: "w-3",
        optionsKey: "provinces",
      },
      {
        name: "actualProperty.actualPropertyCity",
        label: "Ciudad",
        type: "select",
        width: "w-3",
        optionsKey: "cities",
        parentField: "actualProperty.actualPropertyProvince",
      },
      {
        name: "actualProperty.landlord",
        label: "Propietario/Administrador",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "actualProperty.landlordPhone",
        label: "Teléfono del propietario",
        type: "tel",
        width: "w-3",
        maxLength: 10,
      },
      {
        name: "actualProperty.monthlyCost",
        label: "Costo mensual",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "actualProperty.administrationCost",
        label: "Costo de administración",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "actualProperty.antiquity",
        label: "Antigüedad",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
    ],
  },
  {
    title: "Empleado",
    condition: (form) => form.userType === "Empleado",
    fields: [
      {
        name: "employee.company",
        label: "Empresa",
        type: "text",
        width: "w-3",
        maxLength: 150,
        condition: (request) => request.userType === "Empleado",
      },
      {
        name: "employee.address",
        label: "Dirección laboral",
        type: "text",
        width: "w-3",
        maxLength: 150,
        condition: (request) => request.userType === "Empleado",
      },
      {
        name: "employee.position",
        label: "Cargo",
        type: "text",
        width: "w-3",
        maxLength: 100,
        condition: (request) => request.userType === "Empleado",
      },
      {
        name: "employee.salary",
        label: "Salario",
        type: "number",
        width: "w-3",
        min: 0,
        condition: (request) => request.userType === "Empleado",
      },
      {
        name: "employee.admissionDay",
        label: "Fecha de ingreso",
        type: "date",
        width: "w-3",
        condition: (request) => request.userType === "Empleado",
      },
    ],
  },
  {
    title: "Independiente",
    condition: (form) => form.userType === "Independiente",
    fields: [
      {
        name: "independent.activity",
        label: "Actividad principal",
        type: "text",
        width: "w-3",
        maxLength: 150,
        condition: (request) => request.userType === "Independiente",
      },
      {
        name: "independent.address",
        label: "Dirección",
        type: "text",
        width: "w-3",
        maxLength: 150,
        condition: (request) => request.userType === "Independiente",
      },
      {
        name: "independent.employeesNumber",
        label: "No. de empleados",
        type: "number",
        width: "w-3",
        min: 0,
        condition: (request) => request.userType === "Independiente",
      },
      {
        name: "independent.income",
        label: "Ingresos",
        type: "number",
        width: "w-3",
        min: 0,
        condition: (request) => request.userType === "Independiente",
      },
      {
        name: "independent.expenses",
        label: "Egresos",
        type: "number",
        width: "w-3",
        min: 0,
        condition: (request) => request.userType === "Independiente",
      },
    ],
  },
  {
    title: "Pensionado",
    condition: (form) => form.userType === "Pensionado",
    fields: [
      {
        name: "pensionary.reason",
        label: "Razón de la pensión",
        type: "text",
        width: "w-3",
        maxLength: 150,
        condition: (request) => request.userType === "Pensionado",
      },
      {
        name: "pensionary.value",
        label: "Valor de la pensión",
        type: "number",
        width: "w-3",
        min: 0,
        condition: (request) => request.userType === "Pensionado",
      },
    ],
  },
  {
    title: "Propiedades",
    fields: [
      {
        name: "properties",
        label: "Propiedades",
        type: "array",
      },
    ],
  },
  {
    title: "Vehículos",
    fields: [
      {
        name: "vehicles",
        label: "Vehículos",
        type: "array",
      },
    ],
  },
  {
    title: "Información Financiera",
    fields: [
      {
        name: "finantialInformation",
        label: "Información Financiera",
        type: "array",
      },
    ],
  },
  {
    title: "Referencias",
    fields: [
      {
        name: "references",
        label: "Referencias",
        type: "array",
      },
    ],
  },
  {
    title: "Codeudores",
    fields: [
      {
        name: "cosigners",
        label: "Codeudores",
        type: "array",
      },
    ],
  },
]

// Configuración para arrays dinámicos en edición
export const editDynamicArraysConfig = {
  cosigners: {
    title: "Codeudor",
    fields: [
      {
        name: "firstName",
        label: "Nombres",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "lastName",
        label: "Apellidos",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "documentType",
        label: "Tipo de documento",
        type: "select",
        width: "w-3",
        optionsKey: "documentTypes",
      },
      {
        name: "document",
        label: "Número de documento",
        type: "tel",
        width: "w-3",
        maxLength: 30,
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "phone",
        label: "Celular",
        type: "tel",
        width: "w-3",
        maxLength: 10,
      },
      {
        name: "cosignerProvince",
        label: "Departamento",
        type: "select",
        width: "w-3",
        optionsKey: "provinces",
      },
      {
        name: "cosignerCity",
        label: "Ciudad",
        type: "select",
        width: "w-3",
        optionsKey: "cities",
        parentField: "cosignerProvince",
      },
      {
        name: "address",
        label: "Dirección",
        type: "text",
        width: "w-3",
        maxLength: 150,
      },
    ],
  },
  properties: {
    title: "Propiedad",
    fields: [
      {
        name: "type",
        label: "Tipo de propiedad",
        type: "select",
        width: "w-3",
        optionsKey: "propertyTypes",
      },
      {
        name: "address",
        label: "Dirección",
        type: "text",
        width: "w-3",
        maxLength: 150,
      },
      {
        name: "propertyProvince",
        label: "Departamento",
        type: "select",
        width: "w-3",
        optionsKey: "provinces",
      },
      {
        name: "propertyCity",
        label: "Ciudad",
        type: "select",
        width: "w-3",
        optionsKey: "cities",
        parentField: "propertyProvince",
      },
      {
        name: "value",
        label: "Valor",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "realEstateRegistration",
        label: "Matrícula Inmobiliaria",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
    ],
  },
  vehicles: {
    title: "Vehículo",
    fields: [
      {
        name: "type",
        label: "Tipo de vehículo",
        type: "select",
        width: "w-3",
        optionsKey: "vehicleTypes",
      },
      {
        name: "brand",
        label: "Marca",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "model",
        label: "Modelo",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "plaque",
        label: "Placa",
        type: "text",
        width: "w-3",
        maxLength: 20,
      },
    ],
  },
  finantialInformation: {
    title: "Información Financiera",
    fields: [
      {
        name: "type",
        label: "Tipo",
        type: "select",
        width: "w-3",
        optionsKey: "finantialInformationType",
      },
      {
        name: "entity",
        label: "Entidad",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "value",
        label: "Valor",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "fee",
        label: "Cuota",
        type: "number",
        width: "w-3",
        min: 0,
      },
      {
        name: "remaining",
        label: "Saldo",
        type: "number",
        width: "w-3",
        min: 0,
      },
    ],
  },
  references: {
    title: "Referencia",
    fields: [
      {
        name: "type",
        label: "Tipo de referencia",
        type: "select",
        width: "w-3",
        optionsKey: "referenceTypes",
      },
      {
        name: "fullname",
        label: "Nombre completo",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
      {
        name: "phone",
        label: "Teléfono",
        type: "tel",
        width: "w-3",
        maxLength: 10,
      },
      {
        name: "relationship",
        label: "Relación",
        type: "text",
        width: "w-3",
        maxLength: 100,
      },
    ],
  },
}

export const errorMessages = {
  Error: "Hubo un error, vuelve a intentarlo",
  noRequest: "No existe una solicitud con los datos proporcionados",
  activeContract:
    "No puede modificar una solicitud mientras exista un contrato actualmente activo",
  updateSuccess: "Solicitud actualizada con éxito",
}

export const confirmMessages = {
  update: "¿Realmente desea actualizar esta solicitud?",
}
